import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote: "We used to lose leads to slow replies. After Vyomex, every inquiry gets a reply in under a minute — our booking rate went up 2.7X in the first month.",
    name: "Arjun Malhotra",
    role: "Owner, FitZone Gym",
    avatar: "AM",
    accent: "text-[#00F0FF]",
  },
  {
    quote: "As a solo consultant, I was drowning in follow-ups. The automation handles 80% of the back-and-forth now. I closed 3 new retainers last month.",
    name: "Priya Kapoor",
    role: "Business Consultant",
    avatar: "PK",
    accent: "text-[#8B5CF6]",
  },
  {
    quote: "Our tutoring center was missing WhatsApp leads daily. Now every parent gets an instant reply with class slots. Enrollments jumped 40%.",
    name: "Rahul Sharma",
    role: "Director, BrightPath Tutors",
    avatar: "RS",
    accent: "text-[#007AFF]",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <p className="text-xs uppercase tracking-[0.25em] text-[#8B5CF6] mb-4" data-testid="testimonials-kicker">What clients say</p>
          <h2 className="font-display text-4xl sm:text-5xl font-medium text-white leading-tight" data-testid="testimonials-heading">
            Real businesses. Real outcomes.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="glass-card p-8 relative overflow-hidden"
              data-testid={`testimonial-${i}`}
            >
              <Quote className={`${t.accent} mb-5 opacity-60`} size={28} />
              <p className="text-white/80 leading-relaxed text-base mb-6">"{t.quote}"</p>
              <div className="flex items-center gap-3 pt-5 border-t border-white/10">
                <div className={`w-10 h-10 rounded-full bg-white/[0.05] border border-white/10 flex items-center justify-center font-display font-semibold ${t.accent}`}>
                  {t.avatar}
                </div>
                <div className="flex-1">
                  <div className="text-white text-sm font-medium">{t.name}</div>
                  <div className="text-white/50 text-xs">{t.role}</div>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star key={`${t.name}-star-${k}`} size={12} className="fill-[#FFD700] text-[#FFD700]" />
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
